import {
  GeneratedPaymentMethodCardWallet,
  GeneratedPaymentMethodWalletType,
} from '../../../types/generated';

export type KnownCardBrand =
  | 'amex'
  | 'mastercard'
  | 'visa'
  | 'diners'
  | 'discover'
  | 'jcb'
  | 'unionpay'
  | 'eftpos_au';

export type AcceptedCardBrand = KnownCardBrand | (string & {});

export function getBrandAssetUrlFromBrand(brand: AcceptedCardBrand): string {
  switch (brand) {
    case 'amex':
      return '/images/card-brands/amex.svg';

    case 'mastercard':
      return '/images/card-brands/mastercard.svg';

    case 'visa':
      return '/images/card-brands/visa.svg';

    case 'diners':
      return '/images/card-brands/diners.svg';

    case 'discover':
      return '/images/card-brands/discover.svg';

    case 'jcb':
      return '/images/card-brands/jcb.svg';

    case 'unionpay':
      return '/images/card-brands/unionpay.svg';

    case 'unknown':
    case 'eftpos_au':
    default:
      return '/images/card-brands/fallback.svg';
  }
}

export function getWalletAssetUrlFromWalletType(
  wallet: GeneratedPaymentMethodCardWallet | undefined | null,
): string | null {
  if (!wallet) return null;

  switch (wallet.type) {
    case GeneratedPaymentMethodWalletType.ApplePay:
      return '/images/wallet-brands/apple_pay.svg';

    case GeneratedPaymentMethodWalletType.GooglePay:
      return '/images/wallet-brands/google_pay.svg';

    default:
      return null;
  }
}
